export const ID_COLUMN_HYDRATION = 'hydration' as const
